import script from "./WaveAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./WaveAnimation.vue?vue&type=script&setup=true&lang=js"

import "./WaveAnimation.vue?vue&type=style&index=0&id=0690ed30&scoped=true&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0690ed30"]])

export default __exports__